import { doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, store } from "shared/api/firebase";

type Params = { gameId: string; keyImage: string; imagesFile: File };

export const saveGameImages = async ({
  gameId,
  keyImage,
  imagesFile,
}: Params) => {
  // References for logo and background images
  const path = `games/${gameId}/${keyImage}`;
  const imgStorageRef = ref(store, path);

  try {
    await uploadBytes(imgStorageRef, imagesFile);

    // Update Firestore Document
    const docRef = doc(db, "games", gameId);
    await updateDoc(docRef, {
      [keyImage]: path,
      updatedAt: new Date(),
    });
  } catch (error) {
    console.error("Error saving game images:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
